module.exports = __webpack_public_path__ + "media/images/lb/135-f31d0778a40ff2b967fa9ca772dd8218.svg";